import { Table, Input, Button, Modal, Checkbox, Radio } from "antd";
import React, { useEffect, useState } from "react";
import { httpGet, httpUrl, httpPost } from "../../api/httpClient";
import { deletedCode, loginTypeCode } from "../../lib/util/codeUtil"
import UserDialog from "../../components/modal/UserDialog";
import SelectBox from "../../components/common/SelectBox";

const Search = Input.Search;

const CompanyInfo = () => {
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const [list, setList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const [companyInfo, setCompanyInfo] = useState({
        idx: 1, // 업체 고유 식별자
        name: "",
        serviceUrl: "",
        coinType: "",
        webhookTxSync: "",
        webhookReward: "",
        serverIP: "",
        adminIP: ""
    });


    useEffect(() => {
        getCompanyInfo();
    }, []);

    // const getList = async () => {
    //     const endDate = moment(date.end).add(1, 'd').format("YYYY-MM-DD");
    //     const res = await httpGet(httpUrl.getLoginLog, [ endDate, pagination.current, pagination.pageSize, date.start ], {});
    //     console.log(res);        
    //     if (res.result === "SUCCESS" && res.data) {
    //         console.log(res.data.log)
    //         setList(res.data.log);
    //         setPagination({
    //             ...pagination,
    //             current: res.data.currentPage,
    //             total: res.data.totalCount
    //         })
    //     }
    // };


    const getCompanyInfo = async () => {
        try {
            const companyIdx = companyInfo.idx; // companyInfo에서 "1"로 임시 설정
            const response = await httpGet(httpUrl.getCompanyInfo(companyIdx), [], {});
            const data = response.data;
            const result = response.result;
            
            if (result === "SUCCESS" && data != null) {
                setCompanyInfo({
                    idx: companyIdx,
                    name: data.companyName,
                    serviceUrl: data.serviceUrl,
                    coinType: data.symbol,
                    webhookTxSync: data.webhookTransaction,
                    webhookReward: data.webhookWithdrawValidation,
                    serverIP: data.serverIp,
                    adminIP: data.adminIp,
                  });
            } else {
                alert("업체정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요");
            }
        } catch (error) {
            console.error(error);
        }
    };
    
    const showModal = () => {
        setIsModalVisible(true);
    };
    
    const handleOk = () => {
        setIsModalVisible(false);
        updateCompanyInfo();
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };
    
    const updateCompanyInfo = async () => {
        try {
            const updateData = {
                idx: companyInfo.idx,
                webhookTransaction: companyInfo.webhookTxSync,
                webhookWithdrawValidation: companyInfo.webhookReward,
                serverIp: companyInfo.serverIP,
                adminIp: companyInfo.adminIP
            };
            
            const response = await httpPost(httpUrl.updateCompanyInfo, [], updateData);
            console.log(response);

            if (response.result === "SUCCESS") {
                alert("업체 정보가 성공적으로 수정되었습니다.");
              } else {
                alert("업체 정보 수정에 실패했습니다. 다시 시도해주세요.");
              }
        } catch (error) {
            console.error(error);
            alert("업체 정보 수정 중 오류가 발생했습니다.");
        }
    };

    const handleInputChange = (field, value) => {
        setCompanyInfo({
            ...companyInfo,
            [field]: value
        });
    };

    const modalBtn = (
        <div>
          <Button key="cancel" onClick={handleCancel}>
            취소
          </Button>
          <Button key="save" type="primary" onClick={handleOk}>
            저장
          </Button>
        </div>
      );

    return (
        <div id="admin" className="main">
            <div className="main-title">업체 정보</div>
            <div className="container">
                <div className="background-container">
                    <div className="container">
                        <div className="title">
                            업체명
                        </div>
                        <div className="content">
                            {companyInfo.name}
                        </div>
                    </div>

                    <div className="container">
                        <div className="title">
                            서비스 URL
                        </div>
                        <div className="content">
                            {companyInfo.serviceUrl}
                        </div>
                    </div>

                    {/* <div className="container">
                        <div className="title">
                            집금계좌
                        </div>
                        <div className="content">
                            0x4815A7SD55WF1A33F8A5WDFF1A8S52F8A
                        </div>
                    </div> */}

                    <div className="container">
                        <div className="title">
                            취급코인/타입
                        </div>
                        <div className="content">
                            {companyInfo.coinType}
                        </div>
                    </div>

                    {/* <div className="container">
                        <div className="title">
                            네트워크
                        </div>
                        <div className="content">
                            ETH
                        </div>
                    </div>

                    <div className="container">
                        <div className="title">
                            주소발급타입
                        </div>
                        <div className="content">
                            발급형
                        </div>
                    </div>

                    <div className="container">
                        <div className="title">
                            입금타입
                        </div>
                        <div className="content">
                            신청
                        </div>
                    </div>

                    <div className="container">
                        <div className="title">
                            출금타입
                        </div>
                        <div className="content">
                            신청
                        </div>
                    </div>

                    <div className="container">
                        <div className="title">
                            이용수수료 정산타입
                        </div>
                        <div className="content">
                            %
                        </div>
                    </div>

                    <div className="container">
                        <div className="title">
                            시세기준 거래소
                        </div>
                        <div className="content">
                            bybit
                        </div>
                    </div> */}

                    <div>
                        <div className="container">
                            <div className="title">
                                웹훅
                            </div>
                        </div>

                        <div className="container-sub">
                            <div className="sub-title">
                                - 입/출금 완료
                            </div>
                            <Input
                                name="webhookTxSync"
                                className="input"
                                value={companyInfo.webhookTxSync}
                                onChange={(e) => handleInputChange("webhookTxSync", e.target.value)}
                            />
                        </div>

                        <div className="container-sub">
                            <div className="sub-title">
                                - 출금검증
                            </div>
                            <Input
                                name="webhookReward"
                                className="input"
                                value={companyInfo.webhookReward}
                                onChange={(e) => handleInputChange("webhookReward", e.target.value)}
                            />
                        </div>

                        <div className="container-sub">
                            <div className="title"/>
                            <div className="memo">
                            • 웹훅 URL은 "http://" 또는 "https://" 필수입력
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="container">
                            <div className="title">
                                서버 IP
                            </div>
                            <Input
                                name="serverIP"
                                className="input"
                                value={companyInfo.serverIP}
                                onChange={(e) => handleInputChange("serverIP", e.target.value)}
                            />
                        </div>
                    </div>
                    <div>
                        <div className="container">
                            <div className="title">
                                관리자 IP
                            </div>
                            <Input
                                name="adminIP"
                                className="input"
                                value={companyInfo.adminIP}
                                onChange={(e) => handleInputChange("adminIP", e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="container-btn">
                        <Button className="float-btn" onClick={showModal}>
                            수정
                        </Button>
                        <Modal
                            title="업체 정보 수정"
                            visible={isModalVisible}
                            onCancel={handleCancel}
                            footer={modalBtn}
                            centered
                            className="company-modal"
                        >
                            <p>업체정보를 수정하시겠습니까?</p>
                        </Modal>
                    </div>

                </div>
            </div>

        </div>
    );

}

export default CompanyInfo;
